import {Device} from '@aboutyou/grpc-clients/grips/protos/shared/shared.types';
import {Log} from '@aboutyou/mlm';
import {useUserTokenOrSessionId} from '@aboutyou/user';
import {useCallback, useEffect, useRef} from 'react';
import {getUserPermissionsAndFirebaseToken} from '../../backend-services/PushNotification/getUserPermissionsAndFirebaseToken';
import {usePushNotification} from '../../backend-services/PushNotification/usePushNotification';
import {useBrowserSpecificUUID} from '../BrowserSpecificUUID/useBrowserSpecificUUID';
import {DevicePushState} from './enums/DevicePushState';
import {useDevicePushState} from './useDevicePushState';

export const useOnPushNotificationToggle = () => {
  const pushNotificationsAvailable = useRef(false);
  const {updateDevicePushState} = useDevicePushState();
  const {updatePushNotification} = usePushNotification();
  const browserSpecificUUID = useBrowserSpecificUUID();
  const {data: tokenOrSessionId} = useUserTokenOrSessionId();

  useEffect(() => {
    // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
    updateDevicePushState();
    pushNotificationsAvailable.current = 'Notification' in window;
  }, []);

  const onPushNotificationToggle = useCallback(() => {
    const newState = updateDevicePushState();
    getUserPermissionsAndFirebaseToken().then(token => {
      updatePushNotification({
        device: Device.MOBILE_WEB,
        token: token || '',
        devicePushState:
          newState !== DevicePushState.SENT && token ? 'granted' : 'denied',
        uuid: browserSpecificUUID,
        session: tokenOrSessionId!,
      });
      let updatedState: DevicePushState;

      if (!token) {
        updatedState = updateDevicePushState(DevicePushState.BLOCKED);
      } else {
        updatedState = updateDevicePushState(
          newState !== DevicePushState.SENT
            ? DevicePushState.SENT
            : DevicePushState.DISABLED,
        );
      }
      Log.info('@aboutyou/application-mobile', 'PushNotificationEvent', {
        devicePushState: updatedState,
        uuid: browserSpecificUUID,
        tokenReceived: !!token,
        deviceType: Device.MOBILE_WEB,
        returningUserCount: -1,
        flyoutOpened: false,
      });
    });
  }, [browserSpecificUUID, tokenOrSessionId]);

  return {onPushNotificationToggle, pushNotificationsAvailable};
};
